import { render } from "./DraggableGroupsTable.vue?vue&type=template&id=9a404aaa"
import script from "./DraggableGroupsTable.vue?vue&type=script&lang=js"
export * from "./DraggableGroupsTable.vue?vue&type=script&lang=js"

import "./DraggableGroupsTable.vue?vue&type=style&index=0&id=9a404aaa&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__